export default __webpack_public_path__ + "static/media/SAS Alert Tone 2.63f9019f.mp3";